// @flow
export const isTimeOut = (date: string): boolean =>
	new Date().getTime() >= new Date(date).getTime();

export default isTimeOut;


// WEBPACK FOOTER //
// ./src/utils/isTimeOut/index.js